export default __webpack_public_path__ + "static/media/mobileview1.2f16c137.png";